<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import cloneDeep from "lodash/cloneDeep";
import required from "vuelidate/lib/validators/required";
import DatePicker from "vue2-datepicker";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Disposal from "@/components/modals/supply-disposal.vue";
import Employee from "@/components/modals/employee-hris.vue";
import Location from "@/components/modals/property-location.vue";
import AssignmentHistory from "@/router/views/property/components/assignmenthistory";
import CurrentInventory from "@/router/views/property/components/inventory";
import InspectionHistory from "@/router/views/property/components/inspectionhistory";
import Attachments from "@/router/views/property/components/attachments";
import PrintOptions from "@/components/modals/print-options.vue";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "Disposal"
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    MaskedInput,
    Disposal,
    Employee,
    Location,
    AssignmentHistory,
    CurrentInventory,
    InspectionHistory,
    Attachments,
    PrintOptions,
    RawData
  },
  data() {
    return {
      title: "Disposal",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Disposal",
          active: true
        }
      ],
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true
      }),
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      tableData: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptionsLg: [10, 25, 50, 100],
      pageOptionsSm: [5, 10, 20, 50],
      filter: "",
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "id",
          sortable: true,
          label: "Disposal"
        }
      ],
      propertyFields: [
        {
          key: "Name",
          sortable: true
        }
      ],
      editMode: false,
      itemCategory: "",
      backup: {},
      propertyBackup: {},
      indexSelected: -1,
      tableBusy: false,
      inspection: false,
      property: {},
      form: {
        id: "",
        description: "",
        venue: "",
        disposalMethod: "",
        destination: "",
        orNumber: "",
        orDate: "",
        amount: "",
        inspectedBy: "",
        witness: "",
        notes: "",
        campusId: 0
      },
      loading: false,
      employeeName: "",
      getEmployeeType: "",
      assignmentHistoryEmployeeData: null,
      assignmentHistoryLocationData: null,
      editInspection: false,
      tabIndex: 0,
      itemIndex: -1,
      propertyIndex: -1,
      selectedCampus: null,
      campusId: this.$store.state.data.selectedCampus.id
    };
  },
  validations: {
    form: {
      description: { required }
    }
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (
            item.description.toUpperCase().includes(this.filter.toUpperCase())
          )
            return item.description
              .toUpperCase()
              .includes(this.filter.toUpperCase());
        });
      }
      return data;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    }
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
    this.getDraft();
  },
  methods: {
    getDraft() {
      this.tableBusy = true;
      this.$store
        .dispatch(
          "propertydisposal/GetDraftPropertyDisposal",
          this.selectedCampus
        )
        .then((res) => {
          this.tableBusy = false;
          res.data.forEach((item) => {
            item.details = [];
            item.toggleAll = false;
            item.showDetails = false;
            item.rotateChevy = false;
            item.currentPage = 1;
            item.perPage = 5;
            item.filter = "";
            item.tableBusy = false;
          });
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting disposal list!",
            "error"
          );
        });
    },
    getPosted() {
      this.tableBusy = true;
      this.$store
        .dispatch(
          "propertydisposal/GetPostedPropertyDisposal",
          this.selectedCampus
        )
        .then((res) => {
          this.tableBusy = false;
          res.data.forEach((item) => {
            item.details = [];
            item.toggleAll = false;
            item.showDetails = false;
            item.rotateChevy = false;
            item.currentPage = 1;
            item.perPage = 5;
            item.filter = "";
            item.tableBusy = false;
          });
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting disposal list!",
            "error"
          );
        });
    },
    propertyFiltered(row) {
      if (row.showDetails) {
        let data = row.details;
        if (row.filter.trim() != "" && row.filter) {
          data = data.filter((item) => {
            if (item.property.name.toUpperCase().includes(row.filter.toUpperCase())) {
              return item.property.name.toUpperCase().includes(row.filter.toUpperCase());
            } else if (
              item.property.propertyNumber
                .toUpperCase()
                .includes(row.filter.toUpperCase())
            ) {
              return item.property.propertyNumber
                .toUpperCase()
                .includes(row.filter.toUpperCase());
            } else if (
              item.property.serialNumber.toUpperCase().includes(row.filter.toUpperCase())
            ) {
              return item.property.serialNumber
                .toUpperCase()
                .includes(row.filter.toUpperCase());
            }
          });
        }
        return data;
      } else return [];
    },
    propertyRows(row) {
      if (row.filter.trim() != "" && row.filter) {
        return this.propertyFiltered(row).length;
      } else {
        return row.details.length;
      }
    },
    onCreate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.form.campusId = this.selectedCampus;
        this.form.amount = this.form.amount != "" && this.form.amount != null ? this.getExactAmt(this.form.amount) : "0";
        this.form.orDate = this.form.orDate != "" && this.form.orDate != null ? this.getDate(this.form.orDate) : "0001-01-01T00:00:00";
        if (this.form.id) {
          this.$store
            .dispatch("propertydisposal/UpdatePropertyDisposal", this.form)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              // res.data.details = [];
              // res.data.showDetails = false;
              // res.data.rotateChevy = false;
              // res.data.currentPage = 1;
              // res.data.perPage = 5;
              // res.data.filter = "";
              // res.data.tableBusy = false;
              // this.tableData.splice(this.itemIndex, 1, res.data);
              this.getDraft();
              this.$bvModal.hide("modal-create");
              this.showToast("Successfully updated!", "success");
            })
            .catch((err) => {
              this.showToast(
                "Something went wrong - updated disposal!",
                "error"
              );
            });
        } else {
          this.$store
            .dispatch("propertydisposal/CreatePropertyDisposal", this.form)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              // res.data.details = [];
              // res.data.showDetails = false;
              // res.data.rotateChevy = false;
              // res.data.currentPage = 1;
              // res.data.perPage = 5;
              // res.data.filter = "";
              // res.data.tableBusy = false;
              // this.tableData.push(res.data);
              this.getDraft();
              this.$bvModal.hide("modal-create");
              this.showToast("Successfully created!", "success");
            })
            .catch((err) => {
              this.showToast(
                "Something went wrong - creating disposal!",
                "error"
              );
            });
        }
        this.submitted = false;
      }
    },
    createDisposal() {
      this.onReset();
      this.modalTitle = "Create Disposal";
      this.$bvModal.show("modal-create");
    },
    updateDisposal(props) {
      this.onReset();
      this.itemIndex = this.tableData.findIndex((item) => item.id == props.id);
      this.form = cloneDeep(props);
      this.form.amount = this.form.amount.toString();
      this.form.orDate = this.form.orDate.includes("0001-01-01") ? "" : new Date(this.form.orDate);
      this.modalTitle = "Update Disposal";
      this.$bvModal.show("modal-create");
    },
    postDisposal(props) {
      let items = [];
      props.details.forEach((item) => {
        if (item.toggleSelected) {
          items.push({
            id: item.id,
            disposalId: item.disposalId,
            propertyId: item.propertyId,
            name: item.property.name,
            propertyNumber: item.property.propertyNumber,
            accumulatedDepreciation: "",
            accumulatedImpairmentLosses: "",
            carryingAmount: "",
            appraisedValue: "",
            propertyFinalStatus: "",
            inspectionDate: "",
            inspectedBy: "",
            remarks: ""
          });
        }
      });
      this.$refs.disposal.setDisposal(items, props);
    },
    onPostDisposal(disposalId) {
      let disposalIndex = this.tableData.findIndex(
        (item) => item.id == disposalId
      );

      this.tableData[disposalIndex].details = this.tableData[
        disposalIndex
      ].details.filter((item) => {
        return item.toggleSelected == false;
      });

      if (this.tableData[disposalIndex].details.length == 0) {
        this.tableData.splice(disposalIndex, 1);
      }
    },
    unpostDisposal(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, undo post!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          let items = props.details.filter((item) => {
            return item.toggleSelected == true;
          });
          this.$store
            .dispatch(
              "propertydisposal/UnpostMultiplePropertyDisposalItem",
              items
            )
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let disposalIndex = this.tableData.findIndex(
                (item) => item.id == props.id
              );

              this.tableData[disposalIndex].details = this.tableData[
                disposalIndex
              ].details.filter((item) => {
                return item.toggleSelected == false;
              });

              if (this.tableData[disposalIndex].details.length == 0) {
                this.tableData.splice(disposalIndex, 1);
              }
              this.showToast("Successfully returned", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be returned!", "error");
            });
        }
      });
    },
    deleteDisposal(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertydisposal/DeletePropertyDisposal", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.itemIndex = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(this.itemIndex, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    deleteDisposalItem(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, return item!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertydisposal/DeletePropertyDisposalItem", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let disposalIndex = this.tableData.findIndex(
                (item) => item.id == props.disposalId
              );
              let itemIndex = this.tableData[disposalIndex].details.findIndex(
                (item) => item.id == props.id
              );
              this.tableData[disposalIndex].details.splice(itemIndex, 1);
              this.showToast("Successfully returned", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be returned!", "error");
            });
        }
      });
    },
    onReset() {
      this.form = {
        id: "",
        description: "",
        venue: "",
        disposalMethod: "",
        destination: "",
        orNumber: "",
        orDate: "",
        amount: "",
        inspectedBy: "",
        witness: "",
        notes: "",
        campusId: ""
      };
      this.submitted = false;
      this.itemIndex = -1;
      this.propertyIndex = -1;
    },
    getProperty() {
      this.$refs.employee.resetData();
      this.$bvModal.show("externalEmployee-modal");
    },
    dropProperty(data) {
      this.formItems.propertyId = data;
      this.formItems.propertyName = data;
    },
    getEmployee(type) {
      this.$refs.employee.resetData();
      this.$bvModal.show("externalEmployee-modal");
      this.getEmployeeType = type;
    },
    dropEmployee(data) {
      this.assignmentHistoryEmployeeData = data;
    },
    getLocation() {
      this.$refs.location.getData(this.campusId);
      this.$bvModal.show("location-modal");
    },
    dropLocation(data) {
      this.assignmentHistoryLocationData = data;
    },
    showDtls(row, isPosted) {
      row.item.rotateChevy = !row.item.rotateChevy;
      row.item.showDetails = !row.item.showDetails;
      row.item.details = [];
      if (row.item.showDetails) {
        row.item.tableBusy = true;
        row.item.toggleAll = false;
        setTimeout(() => {
          this.$store
            .dispatch("propertydisposal/GetPropertyDisposalItem", {
              id: row.item.id,
              isPosted: isPosted
            })
            .then((res) => {
              res.data.forEach((item) => {
                item.toggleSelected = false;
                item.property.visible = false;
                item.property.itemVisible = false;
                item.property.assignmentHistory = [];
                item.property.assignVisible = false;
                item.property.assignLoading = false;
                item.property.inventory = [];
                item.property.inventoryVisible = false;
                item.property.inventoryLoading = false;
                item.property.inspectionVisible = false;
                item.property.attachmentVisible = false;
                item.property.attachmentLoading = false;
                item.property.addDocu = false;
                item.property.fileSearch = "";
              });
              row.item.details = res.data;
              row.item.tableBusy = false;
            })
            .catch(() => {
              row.item.tableBusy = false;
              this.showToast(
                "Something went wrong - Getting property list!",
                "error"
              );
            });
        }, 1000);
      }
    },
    toggleAll(row, propertyRow, currentPage, perPage) {
      row.details.forEach((item) => {
        item.toggleSelected = false;
      });
      if (row.toggleAll === true) {
        propertyRow.sort((a, b) => a.id - b.id);
        var total = currentPage * perPage;
        var currentData = propertyRow.slice(total - perPage, total);
        if (currentPage > 1 && currentData.length == 0) {
          total = (currentPage - 1) * perPage;
          currentData = propertyRow.slice(total - perPage, total);
        }
        currentData.forEach((item) => {
          item.toggleSelected = true;
        });
      }
    },
    checkToggle(row, propertyRow, currentPage, perPage) {
      propertyRow.sort((a, b) => a.id - b.id);
      var total = currentPage * perPage;
      var currentData = propertyRow.slice(total - perPage, total);
      if (currentPage > 1 && currentData.length == 0) {
        total = (currentPage - 1) * perPage;
        currentData = propertyRow.slice(total - perPage, total);
      }
      var count = 0;
      currentData.forEach((item) => {
        if (item.toggleSelected) count++;
      });
      if (count === currentData.length) {
        row.toggleAll = true;
      } else {
        row.toggleAll = false;
      }
    },
    resetToggle(row) {
      row.toggleAll = false;
      row.details.forEach((item) => {
        item.toggleSelected = false;
      });
    },
    resetAllToggle() {
      this.tableData.forEach((row) => {
        row.toggleAll = false;
        row.details.forEach((item) => {
          item.toggleSelected = false;
        });
      });
    },
    selectedRowCheck(items) {
      var count = 0;
      items.forEach((item) => {
        item.toggleSelected && count++;
      });
      if (count > 0) return true;
      else return false;
    },
    propertyNumberWidth(number) {
      if (number < 100) return "min-width: 35px";
      else if (number < 1000) return "min-width: 50px";
      else if (number < 10000) return "min-width: 60px";
      else return "min-width: 75px";
    },
    changeCampus(data) {
      this.selectedCampus = data.id;
      if (this.tabIndex == 0) {
        this.getDraft();
      } else if (this.tabIndex == 1) {
        this.getPosted();
      }
    },
    async printIndividualSurveyForm(propertyId) {
      var apiUrl = `api/Report/Property/PISF`;
      var routeVariables = [propertyId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables
      });
      this.$bvModal.show("print-options-modal");
    },
    async printIIRUP(disposalId) {
      var apiUrl = `api/Report/Inspection/IIRUP`;
      var routeVariables = [disposalId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables
      });
      this.$bvModal.show("print-options-modal");
    }
  }
};
</script>

<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <!-- Create Disposal -->
    <b-modal id="modal-create" :title="modalTitle" size="md" title-class="font-18" hide-footer no-close-on-backdrop>
      <form @submit.prevent="onCreate" class="needs-validation" ref="fcForm">
        <div class="mb-3">
          <label for="description">Description </label>
          <input id="description" type="text" v-model="form.description" placeholder="Enter Description..."
            class="form-control" :class="{
              'is-invalid': submitted && $v.form.description.$error
            }" autocomplete="off" />
          <div v-if="submitted && $v.form.description.$error" class="invalid-feedback">
            <span v-if="!$v.form.description.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="venue">Venue </label>
          <input id="venue" type="text" v-model="form.venue" placeholder="Enter Venue..." class="form-control"
            autocomplete="off" />
        </div>
        <div class="mb-3">
          <label for="inspectedBy">Inspected By </label>
          <input id="inspectedBy" type="text" v-model="form.inspectedBy" placeholder="Enter Inspector's Name..."
            class="form-control" autocomplete="off" />
        </div>
        <div class="mb-3">
          <label for="witness">Witness </label>
          <input id="witness" type="text" v-model="form.witness" placeholder="Enter Witness..." class="form-control"
            autocomplete="off" />
        </div>
        <div class="mb-3">
          <label for="orNumber">OR Number </label>
          <input id="orNumber" type="text" v-model="form.orNumber" placeholder="Enter OR Number..." class="form-control"
            autocomplete="off" />
        </div>
        <div class="mb-3">
          <label for="orDate">OR Date</label>
          <date-picker v-model="form.orDate" :first-day-of-week="1" lang="en"
            placeholder="Enter Start Date..."></date-picker>
        </div>
        <div class="mb-3">
          <label for="amount">Amount </label>
          <masked-input id="amount" type="text" v-model="form.amount" placeholder="Enter Amount..." class="form-control"
            autocomplete="off" :mask="currencyMask"></masked-input>
        </div>
        <div class="mb-3">
          <label for="notes">Notes </label>
          <textarea id="notes" rows="2" v-model="form.notes" placeholder="Enter Notes..." class="form-control"
            autocomplete="off"></textarea>
        </div>
        <div class="d-flex flex-row-reverse">
          <button type="submit" class="btn btn-primary">{{ this.form.id ? "Update" : "Create" }}</button>
        </div>
      </form>
    </b-modal>
    <!-- Main -->
    <b-tabs content-class="pt-3 pb-3 text-muted" v-model="tabIndex" nav-class="nav-tabs-custom">
      <b-tab @click="getDraft()">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-cancel"></i>
          </span>
          <span class="d-none d-sm-inline-block">Draft</span>
        </template>
        <div v-if="tabIndex == 0" class="card border-4 border-top border-start-0 border-end-0 border-primary">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-6">
                <div class="d-flex align-items-center h-100">
                  <h5 class="mb-0">List of Draft Disposals</h5>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex float-end">
                  <button type="button" @click="createDisposal()"
                    class="btn btn-sm btn-success d-flex align-items-center ms-1">
                    <i class="bx bx-plus fs-6 me-1"></i>Create Disposal
                  </button>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <div class="d-flex float-end">
                  <div id="tickets-table_filter" class="dataTables_filter me-1">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input autocomplete="off" v-model="filter" type="search" @input="currentPage = 1"
                        placeholder="Search Disposal..." class="form-control"></b-form-input>
                    </label>
                  </div>
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center mb-0">
                      <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptionsLg">
                      </b-form-select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="custom-table-responsive mb-0 mt-2">
              <b-table class="propertyTable datatables target-table" :items="filtered" :fields="fields" responsive="sm"
                :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                :busy="tableBusy" bordered outlined striped show-empty>
                <template #empty>
                  <b-card-header>
                    <div class="text-center">
                      <div v-if="filter != ''">
                        <i class="fas fa-exclamation-triangle me-2"></i>There
                        are no disposals matching your request
                      </div>
                      <div v-else>
                        <i class="fas fa-exclamation-triangle me-2"></i>No
                        disposals available
                      </div>
                    </div>
                  </b-card-header>
                </template>
                <template #table-busy>
                  <b-card-header>
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="preloader-component me-2">
                        <div class="status">
                          <div class="spinner-chase w-20px h-20px">
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                          </div>
                        </div>
                      </div>
                      <strong>Loading...</strong>
                    </div>
                  </b-card-header>
                </template>
                <template #cell(id)="row">
                  <div class="position-relative ms-1">
                    <RawData :data="row.item" v-if="$store.state.decrypt.isAdmin()" />
                  </div>
                  <b-card-header header-tag="header" class="border" role="tab">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <b>
                          {{ row.item.description }}
                        </b>
                        <div class="d-flex align-items-center">
                          {{ formatDate(new Date(row.item.disposalDateTime)) }}
                          |
                          <small href="javascript: void(0);"
                            class="text-success d-flex cursor-pointer align-items-center ms-1"
                            @click="showDtls(row, false)">
                            {{ row.item.rotateChevy ? "Hide" : "Show" }}
                            Details
                            <i class="bx bx-chevron-right rotate font-size-14" :class="{
                              'rotate-90': row.item.rotateChevy
                            }"></i>
                          </small>
                        </div>
                      </div>
                      <div>
                        <i class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                          :id="`draft-disposal-popover-${row.item.id}`" tabindex="0"></i>
                        <b-popover :target="`draft-disposal-popover-${row.item.id}`" triggers="click blur"
                          placement="leftbottom" variant="secondary" custom-class="p-0">
                          <b-list-group class="w-100 fit">
                            <b-list-group-item button action class="d-flex align-items-center text-info"
                              @click="updateDisposal(row.item)"><i class="mdi mdi-update font-size-18 me-1"></i>Update
                              Disposal</b-list-group-item>
                            <b-list-group-item button action class="d-flex align-items-center text-danger"
                              @click="deleteDisposal(row.item)"><i
                                class="mdi mdi-trash-can font-size-18 me-1"></i>Delete Disposal</b-list-group-item>
                          </b-list-group>
                        </b-popover>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse :visible="row.item.showDetails">
                    <div v-if="row.item.showDetails">
                      <b-card no-body class="p-3 shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0">
                        <div class="d-flex">
                          <div class="me-3" style="min-width: 280px">
                            <div v-if="row.item.venue" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">Venue:</div>
                              <b style="width: 65%">{{ row.item.venue }}</b>
                            </div>
                            <div v-if="row.item.disposalMethod" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">Method:</div>
                              <b style="width: 65%">{{
                                row.item.disposalMethod
                              }}</b>
                            </div>
                            <div v-if="row.item.destination" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">Destination:</div>
                              <b style="width: 65%">{{
                                row.item.destination
                              }}</b>
                            </div>
                            <div v-if="row.item.orNumber" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">OR Number:</div>
                              <b style="width: 65%">{{ row.item.orNumber }}</b>
                            </div>
                            <div v-if="row.item.orDate" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">OR Date:</div>
                              <b style="width: 65%">{{
                                formatDate(new Date(row.item.orDate))
                              }}</b>
                            </div>
                            <div v-if="row.item.amount" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">Amount:</div>
                              <b style="width: 65%">{{ row.item.amount }}</b>
                            </div>
                            <div v-if="row.item.inspectedBy" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">Inspected By:</div>
                              <b style="width: 65%">{{ row.item.inspectedBy }}</b>
                            </div>
                            <div v-if="row.item.witness" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">Witness:</div>
                              <b style="width: 65%">{{ row.item.witness }}</b>
                            </div>
                            <div v-if="row.item.notes" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">Notes:</div>
                              <b style="width: 65%">{{ row.item.notes }}</b>
                            </div>
                          </div>
                          <div class="border-start border-3 ps-3" style="width: 100%">
                            <div class="d-flex justify-content-between mb-1">
                              <div class="d-flex align-items-center">
                                <div class="p-1 pe-0">
                                  <div class="form-check form-checkbox-outline form-check-success">
                                    <input type="checkbox" :id="`checkbox-draft-${row.item.id}`" checked="checked"
                                      class="form-check-input" @change="
                                        toggleAll(
                                          row.item,
                                          propertyFiltered(row.item),
                                          row.item.currentPage,
                                          row.item.perPage
                                        )
                                        " v-model="row.item.toggleAll" /><label :for="`checkbox-draft-${row.item.id}`"
                                      class="form-check-label">
                                      Select Current Page
                                    </label>
                                  </div>
                                </div>
                                <div class="d-flex align-items-center ms-3">
                                  <div>|</div>
                                  <transition>
                                    <button v-if="
                                      selectedRowCheck(row.item.details) &&
                                      row.item.showDetails
                                    " type="button" class="btn btn-sm btn-success ms-3 d-flex align-items-center"
                                      @click="postDisposal(row.item)">
                                      <i class="bx bx-check-circle fs-6 me-1"></i>
                                      Post Disposal Items
                                    </button>
                                  </transition>
                                </div>
                              </div>
                              <div class="d-flex">
                                <div id="tickets-table_filter" class="dataTables_filter me-1">
                                  <label class="d-inline-flex align-items-center">
                                    <b-form-input autocomplete="off" v-model="row.item.filter" type="search"
                                      placeholder="Search Property..."
                                      class="form-control form-control-sm"></b-form-input>
                                  </label>
                                </div>
                                <div id="tickets-table_length" class="dataTables_length">
                                  <label class="d-inline-flex align-items-center mb-0">
                                    <b-form-select class="form-select form-select-sm" v-model="row.item.perPage"
                                      size="sm" :options="pageOptionsSm">
                                    </b-form-select>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="custom-table-responsive mb-0">
                              <b-table class="propertyTable datatables target-table" thead-class="d-none"
                                :items="propertyFiltered(row.item)" :fields="propertyFields" responsive="sm"
                                :per-page="row.item.perPage" :current-page="row.item.currentPage" sort-by="id"
                                :sort-desc="false" :busy="row.item.tableBusy" show-empty>
                                <template #empty>
                                  <b-card-header>
                                    <div class="text-center">
                                      <div v-if="row.item.filter != ''">
                                        <i class="fas fa-exclamation-triangle me-2"></i>There are no properties matching
                                        your
                                        request
                                      </div>
                                      <div v-else>
                                        <i class="fas fa-exclamation-triangle me-2"></i>No properties available
                                      </div>
                                    </div>
                                  </b-card-header>
                                </template>
                                <template #table-busy>
                                  <b-card-header>
                                    <div class="d-flex justify-content-center align-items-center p-2">
                                      <div class="preloader-component me-2">
                                        <div class="status">
                                          <div class="spinner-chase w-20px h-20px">
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                          </div>
                                        </div>
                                      </div>
                                      <strong>Loading...</strong>
                                    </div>
                                  </b-card-header>
                                </template>
                                <template #cell(name)="propertyRow">
                                  <div class="position-relative ms-1">
                                    <RawData :data="propertyRow.item" v-if="$store.state.decrypt.isAdmin()" />
                                  </div>
                                  <b-card-header header-tag="header" role="tab" class="border">
                                    <div class="d-flex justify-content-between align-items-center">
                                      <div class="d-flex align-items-center pe-5">
                                        <div style="width: 25px"
                                          class="form-check form-checkbox-outline form-check-success me-2">
                                          <input type="checkbox" :id="`propertyId-draft-${propertyRow.item.id}`
                                            " class="form-check-input" @change="
                                              checkToggle(
                                                row.item,
                                                propertyFiltered(row.item),
                                                row.item.currentPage,
                                                row.item.perPage
                                              )
                                              " v-model="propertyRow.item.toggleSelected
                                                " />
                                        </div>
                                        <div :style="propertyNumberWidth(
                                          (currentPage - 1) * perPage +
                                          (propertyRow.index + 1)
                                        )
                                          " class="bg-success bg-gradient text-center me-2 py-1 position-relative">
                                          <h3 class="mb-0 position-relative">
                                            {{
                                              (row.item.currentPage - 1) *
                                              row.item.perPage +
                                              (propertyRow.index + 1)
                                            }}
                                          </h3>
                                        </div>
                                        <div class="text-muted">
                                          <h5 class="mb-0">
                                            {{ propertyRow.item.property.name }}
                                          </h5>
                                          <div style="min-width: max-content">
                                            <small class="d-flex align-items-center">{{
                                              propertyRow.item.property
                                                .propertyNumber &&
                                                propertyRow.item.property
                                                  .propertyNumber !=
                                                "Not Indicated"
                                                ? `Property# ${propertyRow.item.property.propertyNumber}`
                                                : "Not Indicated"
                                            }}
                                              |
                                              <a href="javascript: void(0);"
                                                class="text-success d-flex align-items-center ms-1" @click="
                                                  propertyRow.item.property.visible = !propertyRow
                                                    .item.property.visible
                                                  ">
                                                {{
                                                  propertyRow.item.property
                                                    .visible
                                                    ? "Hide"
                                                    : "Show"
                                                }}
                                                Details
                                                <i class="bx bx-chevron-right rotate font-size-14" :class="{
                                                  'rotate-90':
                                                    propertyRow.item.property
                                                      .visible
                                                }"></i>
                                              </a>
                                            </small>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="float-end d-flex align-items-center ms-3">
                                        <i class="bx bx-printer font-size-18 text-purple cursor-pointer ms-2" :id="`draft-print-popover-${propertyRow.item.id}`
                                          " tabindex="0"></i>
                                        <b-popover :target="`draft-print-popover-${propertyRow.item.id}`
                                          " triggers="click blur" placement="leftbottom" variant="secondary"
                                          custom-class="p-0">
                                          <b-list-group class="w-100 fit">
                                            <b-list-group-item button action class="d-flex align-items-center" @click="
                                              printIndividualSurveyForm(
                                                propertyRow.item.propertyId
                                              )
                                              "><i class="bx bx-printer text-purple font-size-18 me-1"></i>Print
                                              Individual Survey
                                              Form</b-list-group-item>
                                          </b-list-group>
                                        </b-popover>
                                        <div>
                                          <i class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                                            :id="`draft-property-popover-${propertyRow.item.id}`" tabindex="0"></i>
                                          <b-popover :target="`draft-property-popover-${propertyRow.item.id}`"
                                            triggers="click blur" placement="leftbottom" variant="secondary"
                                            custom-class="p-0">
                                            <b-list-group class="w-100 fit">
                                              <b-list-group-item button action
                                                class="d-flex align-items-center text-warning"
                                                @click="deleteDisposalItem(propertyRow.item)"><i
                                                  class="mdi mdi-undo font-size-18 me-1"></i>Return
                                                Item</b-list-group-item>
                                            </b-list-group>
                                          </b-popover>
                                        </div>
                                      </div>
                                    </div>
                                  </b-card-header>
                                  <b-collapse :visible="propertyRow.item.property.visible" role="tabpanel">
                                    <div v-if="propertyRow.item.property.visible">
                                      <b-card no-body
                                        class="shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0">
                                        <!-- Details -->
                                        <b-card-body class="border cursor-pointer" @click="
                                          propertyRow.item.property.itemVisible = !propertyRow
                                            .item.property.itemVisible
                                          ">
                                          <div class="d-flex align-items-center justify-content-between">
                                            <h6 class="mb-0">
                                              <i class="bx bx-menu-alt-right"></i>
                                              Property Details
                                            </h6>
                                            <h5 class="mb-0">
                                              <i class="bx bx-chevron-right rotate" :class="{
                                                'rotate-90':
                                                  propertyRow.item.property
                                                    .itemVisible
                                              }"></i>
                                            </h5>
                                          </div>
                                        </b-card-body>
                                        <b-collapse :visible="propertyRow.item.property
                                          .itemVisible
                                          " role="tabpanel">
                                          <div v-if="
                                            propertyRow.item.property
                                              .itemVisible
                                          ">
                                            <b-card-body class="border">
                                              <b-row>
                                                <b-col sm="7">
                                                  <b class="font-size-15">Property:</b>
                                                  <div class="border border-primary mt-2 mb-3 p-3">
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Property Name:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.name &&
                                                          propertyRow.item
                                                            .property.name !=
                                                          'Not Indicated'
                                                      }">{{
                                                        propertyRow.item
                                                          .property.name
                                                          ? propertyRow.item
                                                            .property.name
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4"><b>PO Number:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .poNumber &&
                                                          propertyRow.item
                                                            .property
                                                            .poNumber !=
                                                          'Not Indicated'
                                                      }">{{
                                                        propertyRow.item
                                                          .property.poNumber
                                                          ? propertyRow.item
                                                            .property
                                                            .poNumber
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Property Number:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .propertyNumber &&
                                                          propertyRow.item
                                                            .property
                                                            .propertyNumber !=
                                                          'Not Indicated'
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .propertyNumber
                                                          ? propertyRow.item
                                                            .property
                                                            .propertyNumber
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4"><b>
                                                          {{
                                                            propertyRow.item
                                                              .property
                                                              .itemCategory
                                                              .type == "SEP"
                                                              ? "ICS"
                                                              : "PAR"
                                                          }}
                                                          Number:
                                                        </b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .currentAssignment &&
                                                          propertyRow.item
                                                            .property
                                                            .currentAssignment
                                                            .assignmentNumber
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .currentAssignment &&
                                                          propertyRow.item
                                                            .property
                                                            .currentAssignment
                                                            .assignmentNumber
                                                          ? propertyRow.item
                                                            .property
                                                            .currentAssignment
                                                            .assignmentNumber
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Serial Number:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .serialNumber &&
                                                          propertyRow.item
                                                            .property
                                                            .serialNumber !=
                                                          'Not Indicated'
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .serialNumber
                                                          ? propertyRow.item
                                                            .property
                                                            .serialNumber
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4"><b>Date Acquired:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .dateAcquired
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .dateAcquired
                                                          ? formatDate(
                                                            new Date(
                                                              propertyRow.item.property.dateAcquired
                                                            )
                                                          )
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4"><b>Warranty Date:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .warrantyStartDate &&
                                                          propertyRow.item
                                                            .property
                                                            .warrantyStartDate !=
                                                          '0001-01-01T00:00:00'
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .warrantyStartDate &&
                                                          propertyRow.item
                                                            .property
                                                            .warrantyStartDate !=
                                                          "0001-01-01T00:00:00"
                                                          ? `${formatDate(
                                                            new Date(
                                                              propertyRow.item.property.warrantyStartDate
                                                            )
                                                          )} - ${formatDate(
                                                            new Date(
                                                              propertyRow.item.property.warrantyEndDate
                                                            )
                                                          )}`
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4"><b>Item Category:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .itemCategory
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .itemCategory
                                                          ? propertyRow.item
                                                            .property
                                                            .itemCategory
                                                            .name
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Supplier:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.supplier
                                                      }">{{
                                                        propertyRow.item
                                                          .property.supplier
                                                          ? propertyRow.item
                                                            .property
                                                            .supplier
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4"><b>Fund Source:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .fundCluster
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .fundCluster
                                                          ? propertyRow.item
                                                            .property
                                                            .fundCluster
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4"><b>Fund Cluster:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.cluster
                                                      }">{{
                                                        propertyRow.item
                                                          .property.cluster
                                                          ? propertyRow.item
                                                            .property
                                                            .cluster.cluster
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Property
                                                          Condition:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .condition
                                                      }">{{
                                                        propertyRow.item
                                                          .property.condition
                                                          ? propertyRow.item
                                                            .property
                                                            .condition
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Unit:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.unit
                                                      }">{{
                                                        propertyRow.item
                                                          .property.unit
                                                          ? propertyRow.item
                                                            .property.unit
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                  </div>

                                                  <b class="font-size-15">Details:</b>
                                                  <div class="border border-primary mt-2 p-3">
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Brand:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.brand
                                                      }">{{
                                                        propertyRow.item
                                                          .property.brand
                                                          ? propertyRow.item
                                                            .property.brand
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Model:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.model
                                                      }">{{
                                                        propertyRow.item
                                                          .property.model
                                                          ? propertyRow.item
                                                            .property.model
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Property
                                                          Specification:</b>
                                                      </b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .specification
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .specification
                                                          ? propertyRow.item
                                                            .property
                                                            .specification
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Color:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.color
                                                      }">{{
                                                        propertyRow.item
                                                          .property.color
                                                          ? propertyRow.item
                                                            .property.color
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Dimension
                                                          Description:</b>
                                                      </b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .dimensionDescription
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .dimensionDescription
                                                          ? propertyRow.item
                                                            .dimensionDescription
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Material Used:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .materialUsed
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .materialUsed
                                                          ? propertyRow.item
                                                            .property
                                                            .materialUsed
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Package
                                                          Description:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .packageDescription
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .packageDescription
                                                          ? propertyRow.item
                                                            .property
                                                            .packageDescription
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row v-if="
                                                      propertyRow.item
                                                        .property.note
                                                    " class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Notes:</b></b-col>
                                                      <b-col class="text-white">{{
                                                        propertyRow.item
                                                          .property.note
                                                      }}</b-col>
                                                    </b-row>
                                                  </div>
                                                </b-col>
                                                <b-col sm="5">
                                                  <b class="font-size-15">Value:</b>
                                                  <div class="border border-primary mt-2 mb-3 p-3">
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Amount:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.amount
                                                      }">{{
                                                        propertyRow.item
                                                          .property.amount
                                                          ? formatCurrency(
                                                            propertyRow.item
                                                              .property
                                                              .amount
                                                          )
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6"><b>Life Span in
                                                          Years:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .lifespanInYears
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .lifespanInYears > 0
                                                          ? propertyRow.item
                                                            .property
                                                            .lifespanInYears
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Salvage Value:</b></b-col>
                                                      <b-col :class="{
                                                        'text-warning':
                                                          propertyRow.item
                                                            .property
                                                            .salvageValue
                                                      }">{{
                                                        formatCurrency(
                                                          propertyRow.item
                                                            .property
                                                            .salvageValue
                                                        )
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Yearly
                                                          Depreciation:</b></b-col>
                                                      <b-col :class="{
                                                        'text-danger':
                                                          propertyRow.item
                                                            .property
                                                            .yearlyDepreciation
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .yearlyDepreciation
                                                      }}%</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Current Value:</b></b-col>
                                                      <b-col :class="{
                                                        'text-warning':
                                                          propertyRow.item
                                                            .property
                                                            .currentValue
                                                      }">{{
                                                        formatCurrency(
                                                          propertyRow.item
                                                            .property
                                                            .currentValue
                                                        )
                                                      }}</b-col>
                                                    </b-row>
                                                  </div>

                                                  <b class="font-size-15">Inspection:</b>
                                                  <div class="border border-primary mt-2 p-3">
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Final Status:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .propertyFinalStatus
                                                      }">{{
                                                        propertyRow.item
                                                          .propertyFinalStatus
                                                          ? propertyRow.item
                                                            .propertyFinalStatus
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Inspection Date:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .inspectionDate &&
                                                          propertyRow.item
                                                            .inspectionDate !=
                                                          '0001-01-01T00:00:00'
                                                      }">{{
                                                        propertyRow.item
                                                          .inspectionDate &&
                                                          propertyRow.item
                                                            .inspectionDate !=
                                                          "0001-01-01T00:00:00"
                                                          ? formatDate(
                                                            new Date(
                                                              propertyRow.item.inspectionDate
                                                            )
                                                          )
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <!-- <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Inspected By:</b>
                                                      </b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .inspectedBy
                                                      }">{{
                                                          propertyRow.item
                                                            .inspectedBy
                                                            ? propertyRow.item
                                                              .inspectedBy
                                                            : "Not Indicated"
                                                        }}</b-col>
                                                    </b-row> -->
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Accumulated
                                                          Depreciation:</b></b-col>
                                                      <b-col :class="{
                                                        'text-warning':
                                                          propertyRow.item
                                                            .accumulatedDepreciation
                                                      }">{{
                                                        propertyRow.item
                                                          .accumulatedDepreciation
                                                          ? formatCurrency(
                                                            propertyRow.item
                                                              .accumulatedDepreciation
                                                          )
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Accumulated
                                                          Impairment Losses:</b></b-col>
                                                      <b-col :class="{
                                                        'text-warning':
                                                          propertyRow.item
                                                            .accumulatedImpairmentLosses
                                                      }">{{
                                                        propertyRow.item
                                                          .accumulatedImpairmentLosses
                                                          ? formatCurrency(
                                                            propertyRow.item
                                                              .accumulatedImpairmentLosses
                                                          )
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Carrying Amount:</b></b-col>
                                                      <b-col :class="{
                                                        'text-warning':
                                                          propertyRow.item
                                                            .carryingAmount
                                                      }">{{
                                                        propertyRow.item
                                                          .carryingAmount
                                                          ? formatCurrency(
                                                            propertyRow.item
                                                              .carryingAmount
                                                          )
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Appraised Value:</b></b-col>
                                                      <b-col :class="{
                                                        'text-warning':
                                                          propertyRow.item
                                                            .appraisedValue
                                                      }">{{
                                                        propertyRow.item
                                                          .appraisedValue
                                                          ? formatCurrency(
                                                            propertyRow.item
                                                              .appraisedValue
                                                          )
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row v-if="
                                                      propertyRow.item.remarks
                                                    " class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Remarks:</b></b-col>
                                                      <b-col class="text-white">{{
                                                        propertyRow.item
                                                          .remarks
                                                      }}</b-col>
                                                    </b-row>
                                                  </div>
                                                </b-col>
                                              </b-row>
                                            </b-card-body>
                                          </div>
                                        </b-collapse>
                                        <AssignmentHistory :key="`all-assignment-${propertyRow.item.property.id}`
                                          " :propertyRow="propertyRow.item.property
                                            " :allowAssign="false" :allowEdit="false" :allowTransfer="false"
                                          :employeeData="assignmentHistoryEmployeeData
                                            " :locationData="assignmentHistoryLocationData
                                              " :ref="`all-assignment-${propertyRow.item.property.id}`
                                                " @getEmployee="getEmployee($event)"
                                          @getLocation="getLocation($event)">
                                        </AssignmentHistory>
                                        <CurrentInventory :key="`all-inventory-${propertyRow.item.property.id}`
                                          " :propertyRow="propertyRow.item.property
                                            " :ref="`all-inventory-${propertyRow.item.property.id}`
                                              "></CurrentInventory>
                                        <InspectionHistory :key="`all-inspection-${propertyRow.item.property.id}`
                                          " :propertyRow="propertyRow.item.property
                                            " :ref="`all-inspection-${propertyRow.item.property.id}`
                                              "></InspectionHistory>
                                        <Attachments :key="`all-attachments-${propertyRow.item.property.id}`
                                          " :propertyRow="propertyRow.item.property
                                            " :ref="`all-attachments-${propertyRow.item.property.id}`
                                              "></Attachments>
                                      </b-card>
                                    </div>
                                  </b-collapse>
                                </template>
                              </b-table>
                            </div>
                            <div class="row">
                              <div v-if="propertyRows(row.item) > 0" class="col">
                                Showing
                                {{
                                  (row.item.currentPage - 1) *
                                  row.item.perPage +
                                  1
                                }}
                                -
                                {{
                                  propertyRows(row.item) >
                                    (row.item.currentPage - 1) *
                                    row.item.perPage +
                                    row.item.perPage
                                    ? (row.item.currentPage - 1) *
                                    row.item.perPage +
                                    row.item.perPage
                                    : propertyRows(row.item)
                                }}
                                of {{ propertyRows(row.item) }}
                              </div>
                              <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                  <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                                    <b-pagination v-model="row.item.currentPage" :total-rows="propertyRows(row.item)"
                                      :per-page="row.item.perPage"></b-pagination>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card>
                    </div>
                  </b-collapse>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab @click="getPosted()">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-cancel"></i>
          </span>
          <span class="d-none d-sm-inline-block">Posted</span>
        </template>
        <div v-if="tabIndex == 1" class="card border-4 border-top border-start-0 border-end-0 border-primary">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="d-flex align-items-center h-100">
                  <h5 class="mb-0">List of Posted Disposals</h5>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex float-end">
                  <div id="tickets-table_filter" class="dataTables_filter me-1">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input autocomplete="off" v-model="filter" type="search" @input="currentPage = 1"
                        placeholder="Search Disposal..." class="form-control"></b-form-input>
                    </label>
                  </div>
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center mb-0">
                      <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptionsLg">
                      </b-form-select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="custom-table-responsive mb-0 mt-2">
              <b-table class="propertyTable datatables target-table" :items="filtered" :fields="fields" responsive="sm"
                :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                :busy="tableBusy" bordered outlined striped show-empty>
                <template #empty>
                  <b-card-header>
                    <div class="text-center">
                      <div v-if="filter != ''">
                        <i class="fas fa-exclamation-triangle me-2"></i>There
                        are no disposals matching your request
                      </div>
                      <div v-else>
                        <i class="fas fa-exclamation-triangle me-2"></i>No
                        disposals available
                      </div>
                    </div>
                  </b-card-header>
                </template>
                <template #table-busy>
                  <b-card-header>
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="preloader-component me-2">
                        <div class="status">
                          <div class="spinner-chase w-20px h-20px">
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                          </div>
                        </div>
                      </div>
                      <strong>Loading...</strong>
                    </div>
                  </b-card-header>
                </template>
                <template #cell(id)="row">
                  <div class="position-relative ms-1">
                    <RawData :data="row.item" v-if="$store.state.decrypt.isAdmin()" />
                  </div>
                  <b-card-header header-tag="header" class="border" role="tab">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <b>
                          {{ row.item.description }}
                        </b>
                        <div class="d-flex align-items-center">
                          {{ formatDate(new Date(row.item.disposalDateTime)) }}
                          |
                          <small href="javascript: void(0);"
                            class="text-success d-flex cursor-pointer align-items-center ms-1"
                            @click="showDtls(row, true)">
                            {{ row.item.rotateChevy ? "Hide" : "Show" }}
                            Details
                            <i class="bx bx-chevron-right rotate font-size-14" :class="{
                              'rotate-90': row.item.rotateChevy
                            }"></i>
                          </small>
                        </div>
                      </div>
                      <div class="float-end d-flex align-items-center ms-3">
                        <i class="bx bx-printer font-size-18 text-purple cursor-pointer ms-2" :id="`posted-disposal-print-popover-${row.item.id}`
                          " tabindex="0"></i>
                        <b-popover :target="`posted-disposal-print-popover-${row.item.id}`
                          " triggers="click blur" placement="leftbottom" variant="secondary" custom-class="p-0">
                          <b-list-group class="w-100 fit">
                            <b-list-group-item button action class="d-flex align-items-center" @click="
                              printIIRUP(
                                row.item.id
                              )
                              "><i class="bx bx-printer text-purple font-size-18 me-1"></i>Print
                              IIRUP</b-list-group-item>
                          </b-list-group>
                        </b-popover>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse :visible="row.item.showDetails">
                    <div v-if="row.item.showDetails">
                      <b-card no-body class="p-3 shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0">
                        <div class="d-flex">
                          <div class="me-3" style="min-width: 280px">
                            <div v-if="row.item.venue" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">Venue:</div>
                              <b style="width: 65%">{{ row.item.venue }}</b>
                            </div>
                            <div v-if="row.item.disposalMethod" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">Method:</div>
                              <b style="width: 65%">{{
                                row.item.disposalMethod
                              }}</b>
                            </div>
                            <div v-if="row.item.destination" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">Destination:</div>
                              <b style="width: 65%">{{
                                row.item.destination
                              }}</b>
                            </div>
                            <div v-if="row.item.orNumber" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">OR Number:</div>
                              <b style="width: 65%">{{ row.item.orNumber }}</b>
                            </div>
                            <div v-if="row.item.orDate" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">OR Date:</div>
                              <b style="width: 65%">{{
                                formatDate(new Date(row.item.orDate))
                              }}</b>
                            </div>
                            <div v-if="row.item.amount" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">Amount:</div>
                              <b style="width: 65%">{{ row.item.amount }}</b>
                            </div>
                            <div v-if="row.item.inspectedBy" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">Inspected By:</div>
                              <b style="width: 65%">{{ row.item.inspectedBy }}</b>
                            </div>
                            <div v-if="row.item.witness" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">Witness:</div>
                              <b style="width: 65%">{{ row.item.witness }}</b>
                            </div>
                            <div v-if="row.item.notes" class="font-size-12 mb-1 d-flex">
                              <div style="width: 35%">Notes:</div>
                              <b style="width: 65%">{{ row.item.notes }}</b>
                            </div>
                          </div>
                          <div class="border-start border-3 ps-3" style="width: 100%">
                            <div class="d-flex justify-content-between mb-1">
                              <div class="d-flex align-items-center">
                                <div class="p-1 pe-0">
                                  <div class="form-check form-checkbox-outline form-check-success">
                                    <input type="checkbox" :id="`checkbox-posted-${row.item.id}`" checked="checked"
                                      class="form-check-input" @change="
                                        toggleAll(
                                          row.item,
                                          propertyFiltered(row.item),
                                          row.item.currentPage,
                                          row.item.perPage
                                        )
                                        " v-model="row.item.toggleAll" /><label :for="`checkbox-posted-${row.item.id}`"
                                      class="form-check-label">
                                      Select Current Page
                                    </label>
                                  </div>
                                </div>
                                <div class="d-flex align-items-center ms-3">
                                  <div>|</div>
                                  <transition>
                                    <button v-if="
                                      selectedRowCheck(row.item.details) &&
                                      row.item.showDetails
                                    " type="button" class="btn btn-sm btn-warning ms-3 d-flex align-items-center"
                                      @click="unpostDisposal(row.item)">
                                      <i class="bx bx-x-circle fs-6 me-1"></i>
                                      Return Disposal Items
                                    </button>
                                  </transition>
                                </div>
                              </div>
                              <div class="d-flex">
                                <div id="tickets-table_filter" class="dataTables_filter me-1">
                                  <label class="d-inline-flex align-items-center">
                                    <b-form-input autocomplete="off" v-model="row.item.filter" type="search"
                                      placeholder="Search Property..."
                                      class="form-control form-control-sm"></b-form-input>
                                  </label>
                                </div>
                                <div id="tickets-table_length" class="dataTables_length">
                                  <label class="d-inline-flex align-items-center mb-0">
                                    <b-form-select class="form-select form-select-sm" v-model="row.item.perPage"
                                      size="sm" :options="pageOptionsSm">
                                    </b-form-select>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="custom-table-responsive mb-0">
                              <b-table class="propertyTable datatables target-table" thead-class="d-none"
                                :items="propertyFiltered(row.item)" :fields="propertyFields" responsive="sm"
                                :per-page="row.item.perPage" :current-page="row.item.currentPage" sort-by="id"
                                :sort-desc="false" :busy="row.item.tableBusy" show-empty>
                                <template #empty>
                                  <b-card-header>
                                    <div class="text-center">
                                      <div v-if="row.item.filter != ''">
                                        <i class="fas fa-exclamation-triangle me-2"></i>There are no properties matching
                                        your
                                        request
                                      </div>
                                      <div v-else>
                                        <i class="fas fa-exclamation-triangle me-2"></i>No properties available
                                      </div>
                                    </div>
                                  </b-card-header>
                                </template>
                                <template #table-busy>
                                  <b-card-header>
                                    <div class="d-flex justify-content-center align-items-center p-2">
                                      <div class="preloader-component me-2">
                                        <div class="status">
                                          <div class="spinner-chase w-20px h-20px">
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                          </div>
                                        </div>
                                      </div>
                                      <strong>Loading...</strong>
                                    </div>
                                  </b-card-header>
                                </template>
                                <template #cell(name)="propertyRow">
                                  <div class="position-relative ms-1">
                                    <RawData :data="propertyRow.item" v-if="$store.state.decrypt.isAdmin()" />
                                  </div>
                                  <b-card-header header-tag="header" role="tab" class="border">
                                    <div class="d-flex justify-content-between align-items-center">
                                      <div class="d-flex align-items-center pe-5">
                                        <div style="width: 25px"
                                          class="form-check form-checkbox-outline form-check-success me-2">
                                          <input type="checkbox" :id="`propertyId-posted-${propertyRow.item.id}`
                                            " class="form-check-input" @change="
                                              checkToggle(
                                                row.item,
                                                propertyFiltered(row.item),
                                                row.item.currentPage,
                                                row.item.perPage
                                              )
                                              " v-model="propertyRow.item.toggleSelected
                                                " />
                                        </div>
                                        <div :style="propertyNumberWidth(
                                          (currentPage - 1) * perPage +
                                          (propertyRow.index + 1)
                                        )
                                          " class="bg-success bg-gradient text-center me-2 py-1 position-relative">
                                          <h3 class="mb-0 position-relative">
                                            {{
                                              (row.item.currentPage - 1) *
                                              row.item.perPage +
                                              (propertyRow.index + 1)
                                            }}
                                          </h3>
                                        </div>
                                        <div class="text-muted">
                                          <h5 class="mb-0">
                                            {{ propertyRow.item.property.name }}
                                          </h5>
                                          <div style="min-width: max-content">
                                            <small class="d-flex align-items-center">{{
                                              propertyRow.item.property
                                                .propertyNumber &&
                                                propertyRow.item.property
                                                  .propertyNumber !=
                                                "Not Indicated"
                                                ? `Property# ${propertyRow.item.property.propertyNumber}`
                                                : "Not Indicated"
                                            }}
                                              |
                                              <a href="javascript: void(0);"
                                                class="text-success d-flex align-items-center ms-1" @click="
                                                  propertyRow.item.property.visible = !propertyRow
                                                    .item.property.visible
                                                  ">
                                                {{
                                                  propertyRow.item.property
                                                    .visible
                                                    ? "Hide"
                                                    : "Show"
                                                }}
                                                Details
                                                <i class="bx bx-chevron-right rotate font-size-14" :class="{
                                                  'rotate-90':
                                                    propertyRow.item.property
                                                      .visible
                                                }"></i>
                                              </a>
                                            </small>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </b-card-header>
                                  <b-collapse :visible="propertyRow.item.property.visible" role="tabpanel">
                                    <div v-if="propertyRow.item.property.visible">
                                      <b-card no-body
                                        class="shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0">
                                        <!-- Details -->
                                        <b-card-body class="border cursor-pointer" @click="
                                          propertyRow.item.property.itemVisible = !propertyRow
                                            .item.property.itemVisible
                                          ">
                                          <div class="d-flex align-items-center justify-content-between">
                                            <h6 class="mb-0">
                                              <i class="bx bx-menu-alt-right"></i>
                                              Property Details
                                            </h6>
                                            <h5 class="mb-0">
                                              <i class="bx bx-chevron-right rotate" :class="{
                                                'rotate-90':
                                                  propertyRow.item.property
                                                    .itemVisible
                                              }"></i>
                                            </h5>
                                          </div>
                                        </b-card-body>
                                        <b-collapse :visible="propertyRow.item.property
                                          .itemVisible
                                          " role="tabpanel">
                                          <div v-if="
                                            propertyRow.item.property
                                              .itemVisible
                                          ">
                                            <b-card-body class="border">
                                              <b-row>
                                                <b-col sm="7">
                                                  <b class="font-size-15">Property:</b>
                                                  <div class="border border-primary mt-2 mb-3 p-3">
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Property Name:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.name &&
                                                          propertyRow.item
                                                            .property.name !=
                                                          'Not Indicated'
                                                      }">{{
                                                        propertyRow.item
                                                          .property.name
                                                          ? propertyRow.item
                                                            .property.name
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4"><b>PO Number:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .poNumber &&
                                                          propertyRow.item
                                                            .property
                                                            .poNumber !=
                                                          'Not Indicated'
                                                      }">{{
                                                        propertyRow.item
                                                          .property.poNumber
                                                          ? propertyRow.item
                                                            .property
                                                            .poNumber
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Property Number:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .propertyNumber &&
                                                          propertyRow.item
                                                            .property
                                                            .propertyNumber !=
                                                          'Not Indicated'
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .propertyNumber
                                                          ? propertyRow.item
                                                            .property
                                                            .propertyNumber
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4"><b>
                                                          {{
                                                            propertyRow.item
                                                              .property
                                                              .itemCategory
                                                              .type == "SEP"
                                                              ? "ICS"
                                                              : "PAR"
                                                          }}
                                                          Number:
                                                        </b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .currentAssignment &&
                                                          propertyRow.item
                                                            .property
                                                            .currentAssignment
                                                            .assignmentNumber
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .currentAssignment &&
                                                          propertyRow.item
                                                            .property
                                                            .currentAssignment
                                                            .assignmentNumber
                                                          ? propertyRow.item
                                                            .property
                                                            .currentAssignment
                                                            .assignmentNumber
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Serial Number:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .serialNumber &&
                                                          propertyRow.item
                                                            .property
                                                            .serialNumber !=
                                                          'Not Indicated'
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .serialNumber
                                                          ? propertyRow.item
                                                            .property
                                                            .serialNumber
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4"><b>Date Acquired:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .dateAcquired
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .dateAcquired
                                                          ? formatDate(
                                                            new Date(
                                                              propertyRow.item.property.dateAcquired
                                                            )
                                                          )
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4"><b>Warranty Date:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .warrantyStartDate &&
                                                          propertyRow.item
                                                            .property
                                                            .warrantyStartDate !=
                                                          '0001-01-01T00:00:00'
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .warrantyStartDate &&
                                                          propertyRow.item
                                                            .property
                                                            .warrantyStartDate !=
                                                          "0001-01-01T00:00:00"
                                                          ? `${formatDate(
                                                            new Date(
                                                              propertyRow.item.property.warrantyStartDate
                                                            )
                                                          )} - ${formatDate(
                                                            new Date(
                                                              propertyRow.item.property.warrantyEndDate
                                                            )
                                                          )}`
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4"><b>Item Category:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .itemCategory
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .itemCategory
                                                          ? propertyRow.item
                                                            .property
                                                            .itemCategory
                                                            .name
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Supplier:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.supplier
                                                      }">{{
                                                        propertyRow.item
                                                          .property.supplier
                                                          ? propertyRow.item
                                                            .property
                                                            .supplier
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4"><b>Fund Source:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .fundCluster
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .fundCluster
                                                          ? propertyRow.item
                                                            .property
                                                            .fundCluster
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4"><b>Fund Cluster:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.cluster
                                                      }">{{
                                                        propertyRow.item
                                                          .property.cluster
                                                          ? propertyRow.item
                                                            .property
                                                            .cluster.cluster
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Property
                                                          Condition:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .condition
                                                      }">{{
                                                        propertyRow.item
                                                          .property.condition
                                                          ? propertyRow.item
                                                            .property
                                                            .condition
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Unit:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.unit
                                                      }">{{
                                                        propertyRow.item
                                                          .property.unit
                                                          ? propertyRow.item
                                                            .property.unit
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                  </div>

                                                  <b class="font-size-15">Details:</b>
                                                  <div class="border border-primary mt-2 p-3">
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Brand:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.brand
                                                      }">{{
                                                        propertyRow.item
                                                          .property.brand
                                                          ? propertyRow.item
                                                            .property.brand
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Model:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.model
                                                      }">{{
                                                        propertyRow.item
                                                          .property.model
                                                          ? propertyRow.item
                                                            .property.model
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Property
                                                          Specification:</b>
                                                      </b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .specification
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .specification
                                                          ? propertyRow.item
                                                            .property
                                                            .specification
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Color:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.color
                                                      }">{{
                                                        propertyRow.item
                                                          .property.color
                                                          ? propertyRow.item
                                                            .property.color
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Dimension
                                                          Description:</b>
                                                      </b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .dimensionDescription
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .dimensionDescription
                                                          ? propertyRow.item
                                                            .dimensionDescription
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Material Used:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .materialUsed
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .materialUsed
                                                          ? propertyRow.item
                                                            .property
                                                            .materialUsed
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Package
                                                          Description:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .packageDescription
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .packageDescription
                                                          ? propertyRow.item
                                                            .property
                                                            .packageDescription
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row v-if="
                                                      propertyRow.item
                                                        .property.note
                                                    " class="mb-2">
                                                      <b-col sm="4">
                                                        <b>Notes:</b></b-col>
                                                      <b-col class="text-white">{{
                                                        propertyRow.item
                                                          .property.note
                                                      }}</b-col>
                                                    </b-row>
                                                  </div>
                                                </b-col>
                                                <b-col sm="5">
                                                  <b class="font-size-15">Value:</b>
                                                  <div class="border border-primary mt-2 mb-3 p-3">
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Amount:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property.amount
                                                      }">{{
                                                        propertyRow.item
                                                          .property.amount
                                                          ? formatCurrency(
                                                            propertyRow.item
                                                              .property
                                                              .amount
                                                          )
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6"><b>Life Span in
                                                          Years:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .property
                                                            .lifespanInYears
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .lifespanInYears > 0
                                                          ? propertyRow.item
                                                            .property
                                                            .lifespanInYears
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Salvage Value:</b></b-col>
                                                      <b-col :class="{
                                                        'text-warning':
                                                          propertyRow.item
                                                            .property
                                                            .salvageValue
                                                      }">{{
                                                        formatCurrency(
                                                          propertyRow.item
                                                            .property
                                                            .salvageValue
                                                        )
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Yearly
                                                          Depreciation:</b></b-col>
                                                      <b-col :class="{
                                                        'text-danger':
                                                          propertyRow.item
                                                            .property
                                                            .yearlyDepreciation
                                                      }">{{
                                                        propertyRow.item
                                                          .property
                                                          .yearlyDepreciation
                                                      }}%</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Current Value:</b></b-col>
                                                      <b-col :class="{
                                                        'text-warning':
                                                          propertyRow.item
                                                            .property
                                                            .currentValue
                                                      }">{{
                                                        formatCurrency(
                                                          propertyRow.item
                                                            .property
                                                            .currentValue
                                                        )
                                                      }}</b-col>
                                                    </b-row>
                                                  </div>

                                                  <b class="font-size-15">Inspection:</b>
                                                  <div class="border border-primary mt-2 p-3">
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Final Status:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .propertyFinalStatus
                                                      }">{{
                                                        propertyRow.item
                                                          .propertyFinalStatus
                                                          ? propertyRow.item
                                                            .propertyFinalStatus
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Inspection Date:</b></b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .inspectionDate
                                                      }">{{
                                                        propertyRow.item
                                                          .inspectionDate
                                                          ? formatDate(
                                                            new Date(
                                                              propertyRow.item.inspectionDate
                                                            )
                                                          )
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <!-- <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Inspected By:</b>
                                                      </b-col>
                                                      <b-col :class="{
                                                        'text-white':
                                                          propertyRow.item
                                                            .inspectedBy
                                                      }">{{
                                                          propertyRow.item
                                                            .inspectedBy
                                                            ? propertyRow.item
                                                              .inspectedBy
                                                            : "Not Indicated"
                                                        }}</b-col>
                                                    </b-row> -->
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Accumulated
                                                          Depreciation:</b></b-col>
                                                      <b-col :class="{
                                                        'text-warning':
                                                          propertyRow.item
                                                            .accumulatedDepreciation
                                                      }">{{
                                                        propertyRow.item
                                                          .accumulatedDepreciation
                                                          ? formatCurrency(
                                                            propertyRow.item
                                                              .accumulatedDepreciation
                                                          )
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Accumulated
                                                          Impairment Losses:</b></b-col>
                                                      <b-col :class="{
                                                        'text-warning':
                                                          propertyRow.item
                                                            .accumulatedImpairmentLosses
                                                      }">{{
                                                        propertyRow.item
                                                          .accumulatedImpairmentLosses
                                                          ? formatCurrency(
                                                            propertyRow.item
                                                              .accumulatedImpairmentLosses
                                                          )
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Carrying Amount:</b></b-col>
                                                      <b-col :class="{
                                                        'text-warning':
                                                          propertyRow.item
                                                            .carryingAmount
                                                      }">{{
                                                        propertyRow.item
                                                          .carryingAmount
                                                          ? formatCurrency(
                                                            propertyRow.item
                                                              .carryingAmount
                                                          )
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Appraised Value:</b></b-col>
                                                      <b-col :class="{
                                                        'text-warning':
                                                          propertyRow.item
                                                            .appraisedValue
                                                      }">{{
                                                        propertyRow.item
                                                          .appraisedValue
                                                          ? formatCurrency(
                                                            propertyRow.item
                                                              .appraisedValue
                                                          )
                                                          : "Not Indicated"
                                                      }}</b-col>
                                                    </b-row>
                                                    <b-row v-if="
                                                      propertyRow.item.remarks
                                                    " class="mb-2">
                                                      <b-col sm="6">
                                                        <b>Remarks:</b></b-col>
                                                      <b-col class="text-white">{{
                                                        propertyRow.item
                                                          .remarks
                                                      }}</b-col>
                                                    </b-row>
                                                  </div>
                                                </b-col>
                                              </b-row>
                                            </b-card-body>
                                          </div>
                                        </b-collapse>
                                        <AssignmentHistory :key="`all-assignment-${propertyRow.item.property.id}`
                                          " :propertyRow="propertyRow.item.property
                                            " :allowAssign="false" :allowEdit="false" :allowTransfer="false"
                                          :employeeData="assignmentHistoryEmployeeData
                                            " :locationData="assignmentHistoryLocationData
                                              " :ref="`all-assignment-${propertyRow.item.property.id}`
                                                " @getEmployee="getEmployee($event)"
                                          @getLocation="getLocation($event)">
                                        </AssignmentHistory>
                                        <CurrentInventory :key="`all-inventory-${propertyRow.item.property.id}`
                                          " :propertyRow="propertyRow.item.property
                                            " :ref="`all-inventory-${propertyRow.item.property.id}`
                                              "></CurrentInventory>
                                        <InspectionHistory :key="`all-inspection-${propertyRow.item.property.id}`
                                          " :propertyRow="propertyRow.item.property
                                            " :ref="`all-inspection-${propertyRow.item.property.id}`
                                              "></InspectionHistory>
                                        <Attachments :key="`all-attachments-${propertyRow.item.property.id}`
                                          " :propertyRow="propertyRow.item.property
                                            " :ref="`all-attachments-${propertyRow.item.property.id}`
                                              "></Attachments>
                                      </b-card>
                                    </div>
                                  </b-collapse>
                                </template>
                              </b-table>
                            </div>
                            <div class="row">
                              <div v-if="propertyRows(row.item) > 0" class="col">
                                Showing
                                {{
                                  (row.item.currentPage - 1) *
                                  row.item.perPage +
                                  1
                                }}
                                -
                                {{
                                  propertyRows(row.item) >
                                    (row.item.currentPage - 1) *
                                    row.item.perPage +
                                    row.item.perPage
                                    ? (row.item.currentPage - 1) *
                                    row.item.perPage +
                                    row.item.perPage
                                    : propertyRows(row.item)
                                }}
                                of {{ propertyRows(row.item) }}
                              </div>
                              <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                  <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                                    <b-pagination v-model="row.item.currentPage" :total-rows="propertyRows(row.item)"
                                      :per-page="row.item.perPage"></b-pagination>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card>
                    </div>
                  </b-collapse>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <Disposal ref="disposal" @postDisposal="onPostDisposal($event)"></Disposal>
    <Employee ref="employee" @dropData="dropEmployee($event)"></Employee>
    <Location ref="location" @dropData="dropLocation($event)"></Location>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.slideUp-enter-active {
  animation: slide-up 0.5s;
}

.slideUp-leave-active {
  animation: slide-up 0.5s reverse;
}

.slide-enter-active {
  animation: slide-in 0.3s;
}

.slide-leave-active {
  animation: slide-in 0.3s reverse;
}

@keyframes slide-in {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-up {
  0% {
    transform: translateY(-30px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.propertyTable tr td {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
